/* ============================================================
   x-branta-reveal — 文案滚动渐入 / 渐出
   作用对象为各文字元素本身（标题、正文、单条规格行，hero / video 除外）：
   - 每个元素独立被 IntersectionObserver 观察，按各自进入触发线的时机渐入，
     因此标题与正文会按各自滚动位置先后出现，互不影响
   - 滚动进入视窗：渐入（.is-visible）
   - 向上滚动、从视窗底部退出：渐出，便于回滚时重新渐入
   - 一直向下浏览、从视窗顶部划走：瞬间复位（.no-anim），不做渐出
   - 始终等待 DOMContentLoaded 后再执行
   - 兼容 Shopify 主题编辑器的 section 重载
   - 无 IntersectionObserver 时直接显示，避免文字被永久隐藏
   - spec-grid 的钉住区块（.x-branta-spec-grid-pin 内部）在桌面端交给
     x-branta-spec-grid-pin.js 按滚动进度分批控制，这里排除掉，避免
     两套逻辑抢着改同一批元素的 is-visible；移动端钉住效果不生效，
     仍由本脚本按常规方式逐个触发
   ============================================================ */
(function () {
  'use strict';

  var REVEAL_SELECTOR = '.x-branta-reveal';
  var VISIBLE_CLASS = 'is-visible'; // 渐入态
  var NO_ANIM_CLASS = 'no-anim'; // 关闭过渡，用于瞬间复位
  // 触发线靠近视窗底部（上移 10%，落在视窗高度 90% 处）。
  // 出现早晚由"文案容器在区域内的位置"自然决定：
  // 文案在区域上部 → 区域滚动约 20%~30% 就进入触发线（早出现）；
  // 文案在区域底部 → 区域要滚动约 70%~80% 才进入触发线（晚出现）。
  var ROOT_MARGIN = '0px 0px -10% 0px';
  // 与 x-branta.css / x-branta-spec-grid-pin.js 保持一致的桌面端断点
  var PIN_MQ = window.matchMedia('(min-width: 769px)');

  function isPinManaged(el) {
    return PIN_MQ.matches && !!el.closest('.x-branta-spec-grid-pin');
  }

  // 渐入
  function show(el) {
    el.classList.remove(NO_ANIM_CLASS);
    el.classList.add(VISIBLE_CLASS);
  }

  // 渐出（向上滚动、从视窗底部退出时）
  function fadeOut(el) {
    el.classList.remove(NO_ANIM_CLASS);
    el.classList.remove(VISIBLE_CLASS);
  }

  // 瞬间复位、不渐出（一直向下浏览、从视窗顶部划走时）
  function resetInstant(el) {
    el.classList.add(NO_ANIM_CLASS);
    el.classList.remove(VISIBLE_CLASS);
  }

  function onIntersect(entries) {
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      var el = entry.target;

      if (entry.isIntersecting) {
        show(el);
        continue;
      }

      // 已离开视窗：判断从顶部还是底部离开
      var rootTop = entry.rootBounds ? entry.rootBounds.top : 0;
      if (entry.boundingClientRect.bottom <= rootTop) {
        // 整体滚到视窗上方 → 向下浏览划过顶部 → 不渐出
        resetInstant(el);
      } else {
        // 仍在视窗下方 → 向上滚动从底部退出 → 渐出
        fadeOut(el);
      }
    }
  }

  function bind(scope) {
    var root = scope || document;
    var all = root.querySelectorAll(REVEAL_SELECTOR);
    var targets = [];
    for (var i = 0; i < all.length; i++) {
      if (!isPinManaged(all[i])) targets.push(all[i]);
    }
    if (!targets.length) return;

    // 旧浏览器降级：直接全部显示
    if (!('IntersectionObserver' in window)) {
      for (var i2 = 0; i2 < targets.length; i2++) {
        targets[i2].classList.add(VISIBLE_CLASS);
      }
      return;
    }

    var observer = new IntersectionObserver(onIntersect, {
      threshold: 0,
      rootMargin: ROOT_MARGIN
    });

    // 逐个实例独立观察
    for (var j = 0; j < targets.length; j++) {
      observer.observe(targets[j]);
    }
  }

  function init() {
    bind(document);
  }

  // 按要求：等待 DOMContentLoaded 之后再执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // 主题编辑器中重新加载该 section 时重新绑定
  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });

  // 跨越桌面/移动断点（如调整窗口宽度）时，重新评估哪些元素归本脚本管，
  // 让 spec-grid 钉住区块的文案能正确交接给对应的控制脚本
  PIN_MQ.addEventListener('change', function () {
    bind(document);
  });
})();
